<template>
  <div class="home page">
    <article class="mauto" v-html="about"></article>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'home',
    created () {
      // this.$store.dispatch('get_data_by_db', 'about')
    },
    mounted () {},
    computed: {
      ...mapState({
        about: 'about'
      })
    }
  }
</script>

<style lang="less">
  .home {
    article {
      width: 90%;
      max-width: 600px;
      text-align: justify;
      padding-top: 20px;
    }
    h4 {
      font-size: 1.8rem;
      margin-bottom: 8px;
    }
    p {
      font-size: 1.8rem;
      margin-top: 0;
      span {
        font-size: 1.6rem;
        margin-top: 10px;
        display: block;
        float: right;
      }
    }
  }

</style>
